import { render, staticRenderFns } from "./ModalEditDocument.vue?vue&type=template&id=71a8d8ce&scoped=true&"
import script from "./ModalEditDocument.vue?vue&type=script&lang=js&"
export * from "./ModalEditDocument.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditDocument.vue?vue&type=style&index=0&id=71a8d8ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8d8ce",
  null
  
)

export default component.exports